import { DayOfWeek } from '@caresend/types';
import { formatDayOfWeek, militaryHourToTime } from './date.js';
import { buildBulletSeparatedString } from './string.js';

const formatOpeningHours = openingHours => {
  const groupedHours = {};

  const sortHourStrings = (a, b) => {
    const aVal = Number(a.openingHour.timeFrom);
    const bVal = Number(b.openingHour.timeFrom);
    return aVal - bVal;
  };

  const sortDays = (a, b) => {
    var _a, _b;

    const aDayOfWeek = (_a = a[0]) === null || _a === void 0 ? void 0 : _a.openingHour.dayFrom;
    const bDayOfWeek = (_b = b[0]) === null || _b === void 0 ? void 0 : _b.openingHour.dayFrom;
    if (!aDayOfWeek && !bDayOfWeek) return 0;
    if (!aDayOfWeek) return 1;
    if (!bDayOfWeek) return -1;
    const aVal = Object.values(DayOfWeek).indexOf(aDayOfWeek);
    const bVal = Object.values(DayOfWeek).indexOf(bDayOfWeek);
    return aVal - bVal;
  };

  const formatGroupedHours = hoursWithFormat => {
    var _a, _b;

    const days = (_b = (_a = hoursWithFormat[0]) === null || _a === void 0 ? void 0 : _a.formattedDays) !== null && _b !== void 0 ? _b : '';
    const times = buildBulletSeparatedString(hoursWithFormat.map(({
      formattedTimes
    }) => formattedTimes));
    return {
      days,
      times
    };
  };

  const joiner = ' - ';
  openingHours.forEach(openingHour => {
    var _a;

    const dayFrom = formatDayOfWeek(openingHour.dayFrom);
    const dayTo = formatDayOfWeek(openingHour.dayTo);
    const timeFrom = militaryHourToTime(Number(openingHour.timeFrom));
    const timeTo = militaryHourToTime(Number(openingHour.timeTo));
    const formattedDays = dayFrom === dayTo ? `${dayFrom}` : `${dayFrom}${joiner}${dayTo}`;
    const formattedTimes = `${timeFrom}${joiner}${timeTo}`;
    const hours = (_a = groupedHours[formattedDays]) !== null && _a !== void 0 ? _a : [];
    hours.push({
      openingHour,
      formattedTimes,
      formattedDays
    });
    hours.sort(sortHourStrings);
    groupedHours[formattedDays] = hours;
  });
  const formattedGroupedHours = Object.values(groupedHours).sort(sortDays).map(formatGroupedHours);
  return formattedGroupedHours;
};
/**
 * Get the open hours for a place on a given day by searching through the
 * `formattedOpeningHours` array. Use `formatOpeningHours` on the place's
 * opening hours to get the array.
 *
 * Either returns the opening hours for the day or 'Closed' if the day is not
 * found.
 *
 * TODO: Does not support when there are multiple opening windows for the same
 * day.
 */

const getHoursForDay = (dayOfWeek, // TODO: Change to DayOfWeek type
formattedOpeningHours) => {
  // TODO: Remove type cast
  const visitDay = formatDayOfWeek(dayOfWeek.toLowerCase());
  /** perhaps we should use an enum for this */

  let result = 'Closed';
  formattedOpeningHours.forEach(({
    days,
    times
  }) => {
    const dayRanges = days.split(' - ');

    if (dayRanges.length === 1 && dayRanges[0] === visitDay) {
      result = times;
    } else {
      const [startDay, endDay] = dayRanges;

      if (!startDay || !endDay) {
        return result;
      }

      const daysOfWeek = Object.values(DayOfWeek).map(weekDay => formatDayOfWeek(weekDay));
      const startIndex = daysOfWeek.indexOf(startDay);
      const endIndex = daysOfWeek.indexOf(endDay);
      const visitDayIndex = daysOfWeek.indexOf(visitDay);
      /** We are searching for the visit day in the range of days */

      if (visitDayIndex >= startIndex && visitDayIndex <= endIndex) {
        result = times;
      }
    }
  });
  return result;
};

export { formatOpeningHours, getHoursForDay };
